import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import Loader from '../../components/loader';
import ViewAutomation from './viewautomation';
import moment from 'moment';

import {
  fetchAddress,
} from '../../actions';

class TableAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addressLoaded: false,
      automationAddresses: [],
    }
    this.copyConfirm = this.copyConfirm.bind(this);
    this.handleAddresses = this.handleAddresses.bind(this)
  }

  componentDidMount() {
    const { dispatch, useAsset } = this.props;

    const data = {
      asset: useAsset,
    };

    dispatch(fetchAddress(data))
      .then((res) => {
        if (res.type === 'FETCH_ADDRESS_SUCCESS') {
          this.handleAddresses();
        }
      });
  }

  copyConfirm(address) {
    if (address) {
      if (document.getElementById(address)) {
        document.getElementById(address).className = "table-copy-i c-i-success";
        setTimeout(() => {
          document.getElementById(address).className = "table-copy-i";
        }, 200);
      }
    }
  }

  handleAddresses() {
    const { dispatch, coins } = this.props;
    const { walletAddresses } = this.state;

    let useAddresses;

    if (coins && coins.length) {
      useAddresses = coins.filter((item) => {
        return item.autoBuy === true;
      });
    }

    this.setState({ automationAddresses: useAddresses, addressLoaded: true });
  }

  render() {
    const { user, errors, success, automations } = this.props;
    const { automationAddresses, addressLoaded } = this.state;

    let useAddress = '';

    if (automationAddresses && (automationAddresses.length || automationAddresses.address)) {
      useAddress = automationAddresses.address || automationAddresses[0].address;
    }

    if (useAddress && addressLoaded) {
      return (
        <>
          <CopyToClipboard
            text={useAddress}
            onCopy={() => this.copyConfirm(useAddress)}
          >
            <div className="table-copy">
              <div className="table-copy-t">
                {useAddress}
              </div>
              <div className="table-copy-i" id={useAddress}>
                <FontAwesomeIcon
                  icon={faCopy}
                  className={'copy-icon'}
                />
              </div>
            </div>
          </CopyToClipboard>
        </>
      );
    }

    return (
      <>
        <Loader small />
      </>
    );
  }

}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
  automations: state.automation.automations,
  loading: state.automation.loading,
  errors: state.automation.errors,
  success: state.automation.success,
  coins: state.coins.coins,
});

export default withRouter(connect(mapStateToProps)(TableAddress));
